"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base64 = require('base-64');
var justOperator;
(function (justOperator) {
    justOperator["Greater"] = ">";
    justOperator["Greaterequal"] = ">=";
    justOperator["Less"] = "<";
    justOperator["Lessequal"] = "<=";
    justOperator["Equal"] = "=";
})(justOperator = exports.justOperator || (exports.justOperator = {}));
/**
 * Answer Status enum : "failed" indicates the function called isn't working or invalid input
 */
var AnswerStatus;
(function (AnswerStatus) {
    AnswerStatus["Success"] = "success";
    AnswerStatus["Failed"] = "failed";
})(AnswerStatus = exports.AnswerStatus || (exports.AnswerStatus = {}));
/**
 * 未知类型探测器
 * @param toCheckData 待检查数据
 * @param toOpFunction 处理数据的函数
 * @param signal 出错位置 /producerpath/valuename
 */
function detect(toCheckData, toOpFunction, signal) {
    if (toCheckData !== undefined && toCheckData !== {} && toCheckData !== null && toCheckData !== '') {
        toOpFunction(toCheckData);
    }
    else {
        if (signal !== null && signal !== undefined) {
            console.error('Unknown type value : ' + signal);
        }
    }
}
exports.detect = detect;
/**
 *
 * @param str
 * @param reg
 */
function isMatchRegex(str, reg) {
    const pattern = new RegExp(reg);
    return pattern.exec(str) ? true : false;
}
exports.isMatchRegex = isMatchRegex;
/**
 * Simplified Unknown value detective
 * @param toCheckData
 */
function simpleDetect(toCheckData) {
    return toCheckData !== undefined && toCheckData !== {} && toCheckData !== null && toCheckData !== '' ? true : false;
}
exports.simpleDetect = simpleDetect;
/**
 * @param toReplace 待替换字段
 * @param replacer 被替换字段
 * @param signal 出错位置 /producerpath/valuename
 * @description 未知类型替代器（指定字段）
 */
function nullReplace(toReplace, replacer, signal) {
    if (toReplace !== undefined && toReplace !== {} && toReplace !== null && toReplace !== '') {
        return toReplace;
    }
    else {
        if (signal !== null) {
            console.error('Unknown type value : ' + signal);
        }
        return replacer;
    }
}
exports.nullReplace = nullReplace;
/**
 * @param obj 解读对象
 * @description 递归解读器, 将对象包括其子对象、数组、属性中全部的未知类型转换成null值, 或者去除。目前版本为去除
 */
function recursionDecipher(obj) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
        // console.log(obj[keys[i]]);
        if (obj[keys[i]] instanceof Array) {
            obj[keys[i]].map((v) => {
                recursionDecipher(v);
            });
        }
        else if (obj[keys[i]] === '' || obj[keys[i]] === [] || obj[keys[i]] === undefined || obj[keys[i]] == null || typeof obj[keys[i]].then === 'function') {
            // obj[keys[i]] = null;
            delete (obj[keys[i]]);
            // console.log(obj[keys[i]] + typeof obj[keys[i]]);
        }
        else if (typeof obj[keys[i]] === 'object' && obj[keys[i]] !== null) {
            recursionDecipher(obj[keys[i]]);
        }
    }
}
exports.recursionDecipher = recursionDecipher;
/**
 * @description a tool to convert string to string array values
 */
class JustConcatter {
    constructor() {
        this.inputType = 'any';
        this.outputType = 'string[]';
        /**
         * @param toConcat 被拼接字符串
         * @param splitter 字符串分隔符
         * @description 智慧型拼装器，a tool to convert string to string array values
         */
        this.smartConcat = (toConcat, splitter) => {
            let strArr = [];
            if (typeof toConcat === 'string') {
                strArr = strArr.concat(toConcat.split(splitter));
            }
            return strArr;
        };
    }
}
exports.JustConcatter = JustConcatter;
/**
 * @param toConvert 被转换对象，
 * @description 将对象转换成对象['key：内容']的字符串数组形式
 */
function justObjConvert(toConvert) {
    let strArr = [];
    strArr = Object.keys(toConvert).map((key) => {
        return (toConvert[key] ? `${key} : ${toConvert[key]}` : '');
    });
    return strArr.filter((str) => str !== '');
}
exports.justObjConvert = justObjConvert;
/**
 * base64 encoder
 * @param str
 * @param salt
 * @param numOfSalt number of Salt
 */
function base64Encoder(str, salt, numOfSalt) {
    if (!(str.length > 0)) {
        return '';
    }
    const strArray = [];
    for (let i = 0; i < str.length; i++) {
        strArray.push(str[i]);
    }
    const numberofSalt = Math.floor(Math.random() * numOfSalt) + 1;
    for (let j = 0; j < numberofSalt; j++) {
        const splitter = Math.floor(Math.random() * strArray.length);
        strArray[splitter] = `${salt}${strArray[splitter]}`;
    }
    return base64.encode(strArray.join(''));
}
exports.base64Encoder = base64Encoder;
function trunc(str, length, ending) {
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = '...';
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    }
    else {
        return str;
    }
}
exports.trunc = trunc;
function wordWrap(str, maxWidth) {
    const newLineStr = '\n';
    let done = false;
    let res = '';
    do {
        let found = false;
        // Inserts new line at first whitespace of the line
        for (let i = maxWidth - 1; i >= 0; i--) {
            if (testWhite(str.charAt(i))) {
                res = res + [str.slice(0, i), newLineStr].join('');
                str = str.slice(i + 1);
                found = true;
                break;
            }
        }
        // Inserts new line at maxWidth position, the word is too long to wrap
        if (!found) {
            res += [str.slice(0, maxWidth), newLineStr].join('');
            str = str.slice(maxWidth);
        }
        if (str.length < maxWidth) {
            done = true;
        }
    } while (!done);
    return res + str;
}
exports.wordWrap = wordWrap;
function testWhite(x) {
    const white = new RegExp(/^\s$/);
    return white.test(x.charAt(0));
}
async function delay(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }
exports.delay = delay;
//# sourceMappingURL=SundryTools.js.map